const { wrapHOC } = require('utils/framework/wrapHOC');
const { wrapHOCComponent } = require('utils/framework/wrapHOCComponent');
const Application = require('utils/framework/Application');
const wrapUFE = require('utils/framework/wrapUFE');
const wrapUFEFunctional = require('utils/framework/wrapUFEFunctional');

module.exports = {
    Application,
    wrapComponent: (component, name, hasCtrlr) => {
        component.class = name;
        const modifiedComponent = wrapUFE(component, hasCtrlr);

        return modifiedComponent;
    },
    wrapFunctionalComponent: wrapUFEFunctional,
    wrapHOC,
    wrapHOCComponent
};
